export default __webpack_public_path__ + "static/media/04_prase_II_Pospisil-min.29d6b609.jpg";